import React from 'react';
import Image from 'frontastic/lib/image';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import Wysiwyg from 'components/commercetools-ui/organisms/wysiwyg';

import '../../../../../../styles/components/wysiwyg.css';
const SectionWithHeadingAndDescription = (props: any) => {
  const { content } = props;
  //console.log('SectionWithHeadingAndDescription', content)

  return (
    <div className={`${content.additional_css ?? ''}`}>
      <div className="">
        <div className={`w-[min(100%,47rem)] 2xl:text-40 xl:text-30 text-24 m-auto title font-medium leading-10 text-primary-black lg:border-none pt-40 pb-12 2xl:pt-80 2xl:pb-12 `}>
          {content.title}
        </div>
        <Wysiwyg markdown={content.description} className="max-w-[47rem]"/>
      </div>
    </div>
  );
};

export default SectionWithHeadingAndDescription;